import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <Link to="/" className="back-to-home">
            ← Volver al inicio
          </Link>
          <h1 className="legal-title">🍪 Política de Cookies</h1>
          <p className="legal-subtitle">GesOps LLC - Información sobre el uso de cookies</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. ¿Qué son las Cookies?</h2>
            <p>
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. 
              Nos ayudan a mejorar su experiencia de navegación y a proporcionar servicios más personalizados.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Tipos de Cookies que Utilizamos</h2>
            
            <h3>2.1 Cookies Esenciales</h3>
            <p>Estas cookies son necesarias para el funcionamiento básico del sitio web:</p>
            <ul>
              <li><strong>Cookies de sesión:</strong> Mantienen su sesión activa durante la navegación</li>
              <li><strong>Cookies de seguridad:</strong> Protegen contra ataques y fraudes</li>
              <li><strong>Cookies de funcionalidad:</strong> Recuerdan sus preferencias de idioma y región</li>
            </ul>

            <h3>2.2 Cookies de Rendimiento</h3>
            <p>Nos ayudan a entender cómo los usuarios interactúan con nuestro sitio:</p>
            <ul>
              <li><strong>Google Analytics:</strong> Analiza el tráfico y comportamiento de usuarios</li>
              <li><strong>Cookies de velocidad:</strong> Miden el rendimiento del sitio web</li>
              <li><strong>Cookies de error:</strong> Detectan problemas técnicos</li>
            </ul>

            <h3>2.3 Cookies de Funcionalidad</h3>
            <p>Mejoran su experiencia de usuario:</p>
            <ul>
              <li><strong>Preferencias de usuario:</strong> Recuerdan sus configuraciones</li>
              <li><strong>Formularios:</strong> Guardan información parcialmente completada</li>
              <li><strong>Búsquedas:</strong> Recuerdan sus búsquedas recientes de abogados</li>
            </ul>

            <h3>2.4 Cookies de Marketing (Opcionales)</h3>
            <p>Con su consentimiento, utilizamos cookies para:</p>
            <ul>
              <li><strong>Publicidad dirigida:</strong> Mostrar anuncios relevantes</li>
              <li><strong>Redes sociales:</strong> Integración con plataformas sociales</li>
              <li><strong>Remarketing:</strong> Personalizar contenido en otros sitios</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Cookies de Terceros</h2>
            <p>Algunos servicios de terceros pueden establecer cookies en nuestro sitio:</p>
            
            <h3>3.1 Google Services</h3>
            <ul>
              <li><strong>Google Analytics:</strong> Análisis de tráfico web</li>
              <li><strong>Google Maps:</strong> Mapas interactivos (si aplicable)</li>
              <li><strong>Google Fonts:</strong> Fuentes web optimizadas</li>
            </ul>

            <h3>3.2 Redes Sociales</h3>
            <ul>
              <li><strong>Facebook:</strong> Botones de compartir y plugins</li>
              <li><strong>LinkedIn:</strong> Integración profesional</li>
              <li><strong>WhatsApp:</strong> Widget de chat</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Gestión de Cookies</h2>
            
            <h3>4.1 Control del Navegador</h3>
            <p>Puede controlar las cookies a través de su navegador:</p>
            <ul>
              <li><strong>Aceptar todas:</strong> Permite todas las cookies</li>
              <li><strong>Rechazar opcionales:</strong> Solo cookies esenciales</li>
              <li><strong>Configuración personalizada:</strong> Elegir tipos específicos</li>
              <li><strong>Eliminar existentes:</strong> Borrar cookies almacenadas</li>
            </ul>

            <h3>4.2 Instrucciones por Navegador</h3>
            <ul>
              <li><strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies</li>
              <li><strong>Firefox:</strong> Opciones → Privacidad y seguridad → Cookies</li>
              <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies</li>
              <li><strong>Edge:</strong> Configuración → Cookies y permisos del sitio</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Impacto de Deshabilitar Cookies</h2>
            <p>Si deshabilita las cookies, algunas funciones pueden verse afectadas:</p>
            
            <h3>5.1 Cookies Esenciales Deshabilitadas</h3>
            <ul>
              <li>Problemas de navegación y funcionalidad</li>
              <li>Pérdida de preferencias de usuario</li>
              <li>Posibles problemas de seguridad</li>
            </ul>

            <h3>5.2 Cookies Opcionales Deshabilitadas</h3>
            <ul>
              <li>Experiencia menos personalizada</li>
              <li>Anuncios menos relevantes</li>
              <li>Funciones sociales limitadas</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Duración de las Cookies</h2>
            
            <h3>6.1 Cookies de Sesión</h3>
            <p>Se eliminan automáticamente cuando cierra el navegador.</p>

            <h3>6.2 Cookies Persistentes</h3>
            <ul>
              <li><strong>Preferencias:</strong> 1 año</li>
              <li><strong>Analytics:</strong> 2 años</li>
              <li><strong>Marketing:</strong> 30-90 días</li>
              <li><strong>Funcionalidad:</strong> 6 meses</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Actualizaciones de la Política</h2>
            <p>
              Esta Política de Cookies puede actualizarse periódicamente. Los cambios significativos 
              serán notificados a través de nuestro sitio web.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Sus Derechos</h2>
            <p>En relación con las cookies, usted tiene derecho a:</p>
            <ul>
              <li>Ser informado sobre el uso de cookies</li>
              <li>Dar o retirar su consentimiento</li>
              <li>Acceder a información sobre cookies almacenadas</li>
              <li>Solicitar la eliminación de cookies</li>
              <li>Configurar preferencias específicas</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Contacto</h2>
            <p>
              Para preguntas sobre nuestra Política de Cookies:
            </p>
            <div className="legal-contact-info">
              <p><strong>GesOps LLC</strong></p>
              <p>📧 Email: info@gesops.com</p>
              <p>🏢 Dirección: 1420 Celebration Blvd, Suite 101, Celebration, FL 34747, Estados Unidos</p>
              <p><strong>Asunto:</strong> "Consulta sobre Cookies"</p>
            </div>
          </section>

          <div className="legal-disclaimer">
            <p>
              <strong>Nota:</strong> El uso de cookies en nuestro sitio web está diseñado para mejorar su experiencia 
              mientras respetamos su privacidad y cumplimos con las regulaciones aplicables.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
